<template>
  <div class="contents">
    <top></top>
    <div class="content-body">
      <div class="content-title">账户信息</div>
      <div class="content-item">
        <div class="content-label">用户名:</div>
        <div class="content-text">
          {{ userInfo.userName || "暂无" }}
        </div>
      </div>
      <div class="content-item">
        <div class="content-label">邮箱:</div>
        <div class="content-text">
          {{ userInfo.userName || "暂无" }}
        </div>
      </div>
      <div class="content-item">
        <div class="content-label">登录密码:</div>
        <div class="content-text">
          ******
        </div>
        <div class="content-button">
          <el-link :underline="false" @click="editPassword" type="primary"
            >更改</el-link
          >
          <el-link :underline="false" @click="refPassword" type="primary"
            >重置</el-link
          >
        </div>
      </div>
      <!-- <div class="content-item">
        <div class="content-label">邀请码:</div>
        <div class="content-text" style="color: #999999">
          {{ userInfo.inviteCode || "暂无" }}
        </div>
        <div class="content-button">
          <el-link
            :underline="false"
            @click="copyCode(userInfo.inviteCode)"
            type="primary"
            >复制</el-link
          >
        </div>
      </div> -->
    </div>
    <div class="content-body">
      <div class="content-title">成员信息</div>
      <div class="content-item">
        <div class="content-label">成员昵称:</div>
        <div class="content-text">
          {{ userInfo.nickName || "暂无" }}
        </div>
        <div class="content-button">
          <el-link
            :underline="false"
            @click="editNickName"
            style="font-size: 18px"
            type="primary"
            icon="el-icon-edit-outline"
          ></el-link>
        </div>
      </div>
      <div class="content-item">
        <div class="content-label">成员角色:</div>
        <div class="content-text">
          {{ roles.indexOf("admin") > -1 ? "管理员" : "普通成员" }}
        </div>
      </div>
      <div class="content-item">
        <div class="content-label">成员头像:</div>
        <div class="content-text">
          <file-upload
            class="avatar-uploader"
            :action="imageAction"
            :showLoading="true"
            :maxSize="maxSize"
            @success="onUploadSuccess"
            :fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']"
          >
            <img
              v-if="userInfo.headImage"
              :src="userInfo.headImage"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </file-upload>
        </div>
      </div>
    </div>

    <el-dialog title="更改" :visible.sync="dialogVisible" width="30%">
      <el-form
        ref="form"
        :model="form"
        label-width="80px"
        label-position="left"
        :rules="rules"
      >
        <el-form-item label="原密码" prop="oldPassword">
          <el-input
            v-model.trim="form.oldPassword"
            type="password"
            size="small"
            clearable
            placeholder="请输入原密码"
          />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model.trim="form.newPassword"
            type="password"
            size="small"
            clearable
            placeholder="请输入新密码"
          />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model.trim="form.confirmPassword"
            type="password"
            size="small"
            clearable
            placeholder="请确认密码"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editPwd">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="重置" :visible.sync="dialogVisible2" width="30%">
      <el-form
        ref="form2"
        :model="form2"
        label-width="80px"
        label-position="left"
        :rules="rules2"
      >
        <el-form-item label="密码" prop="newPassword">
          <el-input
            v-model="form2.newPassword"
            type="password"
            size="small"
            clearable
            placeholder="请输入密码"
          />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="form2.confirmPassword"
            type="password"
            size="small"
            clearable
            placeholder="请确认密码"
          />
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <div style="display: flex; align-items: center">
            <el-input
              v-model="form2.code"
              size="small"
              clearable
              placeholder="请输入验证码"
            />
            <el-button
              type="primary"
              :disabled="countdown > 0"
              size="small"
              @click="sendCode"
              style="margin-left: 10px; height: 100%"
              >{{
                countdown > 0 ? countdown + "s后重新发送" : "获取验证码"
              }}</el-button
            >
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="refPwd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { initRsaPublicKey, rsaEncryptPassword } from "../../utils/encrypt";
import top from "./components/top.vue";
import FileUpload from "../common/FileUpload.vue";
export default {
  data() {
    const passwordValidator = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(rule.message));
      }
      if (value.length < 5 || value.length > 20) {
        return callback(new Error("密码长度需在 5 到 20 个字符"));
      }
      if (/\s/.test(value)) {
        return callback(new Error("密码不能包含空格"));
      }
      callback();
    };
    return {
      maxSize: 5 * 1024 * 1024,
      dialogVisible: false,
      dialogVisible2: false,
      countdown: 0,
      timer: null,
      form: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      form2: {
        newPassword: "",
        confirmPassword: "",
        code: "",
      },
      rules: {
        oldPassword: [
          {
            required: true,
            validator: passwordValidator,
            message: "请输入原密码",
            trigger: "blur",
          },
        ],
        newPassword: [
          {
            required: true,
            validator: passwordValidator,
            message: "请输入新密码",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error("请确认密码"));
              }
              if (value.length < 5 || value.length > 20) {
                return callback(new Error("密码长度需在 5 到 20 个字符"));
              }
              if (/\s/.test(value)) {
                return callback(new Error("密码不能包含空格"));
              }
              if (value !== this.form.newPassword) {
                return callback(new Error("两次输入的密码不一致"));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
      rules2: {
        newPassword: [
          {
            required: true,
            validator: passwordValidator,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error("请确认密码"));
              }
              if (value.length < 5 || value.length > 20) {
                return callback(new Error("密码长度需在 5 到 20 个字符"));
              }
              if (/\s/.test(value)) {
                return callback(new Error("密码不能包含空格"));
              }
              if (value !== this.form2.newPassword) {
                return callback(new Error("两次输入的密码不一致"));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userStore.userInfo;
    },
    roles() {
      return this.$store.state.userStore.roles;
    },
    imageAction() {
      return `/image/upload`;
    },
  },
  components: {
    top,
    FileUpload,
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    sendCode() {
      this.countdown = 60;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
      this.$http({
        url: "/sendEmailCode",
        method: "post",
        data: {
          email: this.userInfo.userName,
        },
      });
    },
    editPassword() {
      this.form = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      };
      this.dialogVisible = true;
    },
    refPassword() {
      this.form2 = {
        newPassword: "",
        confirmPassword: "",
        code: "",
      };
      this.dialogVisible2 = true;
    },
    editPwd() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm("你确定要更改密码吗?, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(async() => {
            await initRsaPublicKey();
            this.$http({
              url: "/modifyPwd",
              method: "put",
              data: {
                publicKey: this.$store.state.userStore.PublicKey,
                oldPassword: rsaEncryptPassword(this.form.oldPassword),
                newPassword: rsaEncryptPassword(this.form.newPassword),
                confirmPassword: rsaEncryptPassword(this.form.confirmPassword),
              },
            }).then(() => {
              this.$message.success("修改成功");
              this.dialogVisible = false;
            });
          });
        }
      });
    },
    refPwd() {
      this.$refs.form2.validate((valid) => {
        if (valid) {
          this.$confirm("你确定要重置密码吗?, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(async() => {
            await initRsaPublicKey();
            this.$http({
              url: "/customer/resetPwd",
              method: "post",
              data: {
                publicKey: this.$store.state.userStore.PublicKey,
                newPassword: rsaEncryptPassword(this.form2.newPassword),
                confirmPassword: rsaEncryptPassword(this.form2.confirmPassword),
                code: this.form2.code,
              },
            }).then(() => {
              this.$message.success("修改成功");
              this.dialogVisible2 = false;
            });
          });
        }
      });
    },
    async copyCode(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$message.success("复制成功");
      } catch (err) {
        this.$message.error("复制失败");
      }
    },
    onUploadSuccess(data, file) {
      this.userInfo.headImage = data.originUrl;
      this.userInfo.headImageThumb = data.thumbUrl;
      this.onSubmit(this.userInfo);
    },
    editNickName() {
      this.$prompt("请输入昵称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputErrorMessage: "最多 30 个字符",
        inputValidator: (value) => {
          if (!value) return "昵称不能为空";
          if (value.length > 30) return "昵称不能超过 30 个字符";
          return true;
        },
      }).then(({ value }) => {
        let data = {
          ...this.userInfo,
          nickName: value,
        };
        this.onSubmit(data);
      });
    },
    onSubmit(data) {
      this.$http({
        url: "/user/update",
        method: "put",
        data: data,
      }).then(() => {
        this.$store.dispatch("loadUser");
        this.$message.success("修改成功");
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  .content-title {
    font-weight: 500;
    font-size: 15px;
  }
  .content-item {
    font-size: 15px;
    display: flex;
    padding-top: 20px;
    .content-label {
      width: 80px;
      text-align: left;
      color: #666666;
    }
    .content-text {
      text-align: left;
      min-width: 180px;
      margin: 0 20px;
    }
    .content-button {
      a {
        margin-right: 10px;
      }
    }
  }
}

.avatar-uploader {
  --width: 112px;

  .el-upload {
    border: 1px dashed #d9d9d9 !important;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 24px;
    color: #8c939d;
    width: var(--width);
    height: var(--width);
    line-height: var(--width);
    text-align: center;
  }

  .avatar {
    width: var(--width);
    height: var(--width);
    display: block;
    object-fit: cover;
  }
}

.baseForm-input {
  width: 100%;
}

::v-deep .el-upload {
  border-radius: 50% !important;
  overflow: hidden;
}
</style>
